import { useTranslation } from '../../../lib/i18n';
import { docSource } from '../../../lib/doc-viewer';
import { ScrollArea, Typography } from '../ui';
import styles from './DocViewerModal.module.css';

// A video artifact — `<video controls preload="metadata">`, source resolved directly from `docSource`
// (remote only; see `ImageDocView`'s note on why this never goes through `useDocText`).
export function VideoDocView({ content, fileName }: { content?: string | null; fileName: string }) {
  const { t } = useTranslation();
  const source = docSource(content);
  const url = source?.kind === 'remote' ? source.url : null;

  if (!url) {
    return (
      <div className={styles.state}>
        <Typography variant="p2" color="secondary" component="p">
          {t('docViewer.videoUnavailable')}
        </Typography>
      </div>
    );
  }

  return (
    <ScrollArea className={styles.mediaBody}>
      {/* An agent-produced artifact carries no captions track. */}
      <video controls preload="metadata" className={styles.mediaVideo} aria-label={fileName}>
        <source src={url} />
      </video>
    </ScrollArea>
  );
}
